import { Button } from '@shared/components/ui/button';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface CreatePackagingButtonProps {
  onCreatePackaging: () => void;
}

export const CreatePackagingButton: React.FC<CreatePackagingButtonProps> = ({ onCreatePackaging }) => {
  const { t } = useTranslation('materialAlmacenModule');

  const handleCreate = useCallback(() => {
    onCreatePackaging();
  }, [onCreatePackaging]);

  return (
    <Button variant="primary" size="lg" onClick={handleCreate} data-testid="create-packaging-button">
      {t('actions.create_material')}
    </Button>
  );
};
